<template>
    <div class="tag-list" v-if="tags?.length" ref="wrapper">
        <TagChip v-for="tag in visible" :key="tag.id" :tag="tag" :size="size" />
        <button
            v-if="hidden.length"
            type="button"
            class="more"
            :class="size"
            @click.stop.prevent="toggle">
            +{{ hidden.length }}
        </button>
        <div v-if="opened" class="overflow">
            <TagChip v-for="tag in hidden" :key="tag.id" :tag="tag" :size="size" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import type { Tag } from '@ezio/features/tags/types'
import TagChip from './TagChip.vue'

const props = withDefaults(
    defineProps<{
        tags: Tag[]
        max?: number
        size?: 'sm' | 'md'
    }>(),
    {
        max: 3,
        size: 'sm'
    }
)

const opened = ref(false)
const wrapper = ref<HTMLElement | null>(null)
onClickOutside(wrapper, () => (opened.value = false))

const visible = computed(() => (props.tags ?? []).slice(0, props.max))
const hidden = computed(() => (props.tags ?? []).slice(props.max))

const toggle = () => {
    opened.value = !opened.value
}
</script>

<style lang="scss" scoped>
.tag-list {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
}

.more {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    border: 1px solid var(--c-color-border-soft);
    background: transparent;
    color: var(--c-color-text-soft);
    font-family: 'Sora', sans-serif;
    cursor: pointer;
    padding: 2px 8px;
    line-height: 1;

    &.sm {
        font-size: 0.7rem;
    }
    &.md {
        font-size: 0.8rem;
        padding: 4px 10px;
    }

    &:hover {
        color: var(--c-text-color);
    }
}

.overflow {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 6px;
    z-index: 50;
    background: #fff;
    border: 1px solid var(--c-color-border-soft);
    border-radius: 8px;
    padding: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    box-shadow:
        0 1px 2px rgba(0, 0, 0, 0.04),
        0 4px 12px rgba(0, 0, 0, 0.08);
    min-width: 160px;
    max-width: 260px;
}
</style>
